import React, { Component } from 'react'
import { FaRegBookmark, FaBookmark } from "react-icons/fa6";
import MathJaxPreview from '../../../../components/react-mathjax-preview';
import MathParserUtil from '../../../../lib/math-parser';

class SFCompactQA extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isBookmarked: false,
        }
    }


    render() {
        console.debug("this.props.answersContentDisplay>>", this.props.answersContentDisplay)
        return (
            <div className='d-flex justify-content-start pb-5 position-relative w-100'>
                <div className='cursor-pointer q-bookmark' 
                    onClick={() => {
                        // this.handleBookmarkClick()
                        this.setState({
                            isBookmarked: !this.state.isBookmarked
                        })
                        this.props.handleBookmarkClick()
                    }}
                >
                    {this.state.isBookmarked ? 
                        <FaBookmark fontSize={18} fontWeight={100} color='#ad8200' /> :
                        <FaRegBookmark fontSize={18} fontWeight={100} color='#666' />
                    }
                    
                </div>
                <div className='sf-compact-qa-container'>
                    <div className='sf-compact-qa-question-no' id={`question-no-${this.props.questionNo}`}>
                        Question {this.props.questionNo}
                    </div>
                    <div className='sf-compact-qa-question'>
                        <MathJaxPreview math={MathParserUtil.setVariablesToText(this.props.questionText, this.props.currentVariableMap)} />
                    </div>
                    <div className='w-100 d-flex justify-content-center pb-4'>
                        <div style={{
                            width: '95%',
                            borderBottom: '1px solid #dddddd'
                        }}>

                        </div>
                    </div>
                    <div className='sf-compact-qa-answer'>
                        {this.props.answersContentDisplay}
                    </div>
                </div>

            </div>
        )
    }
}

export default SFCompactQA;